const dataEN = {
  readMore: "Read More",
  prev: "Prev",
  next: "Next",
  blogs: [
      {
        id: 1,
        image: "/assets/images/Blog/bloglist1.png",
        title: "What Is IFU (Unique Financial Identifier)? Meaning, Benefits & Registration Process",
        excerpt:"IFU number, Unique Financial Identifier, IFU meaning, What is IFU, IFU tax number, IFU registration, IFU benefits, How to get IFU, IFU for business, IFU compliance"      },
      {
        id: 2,
        image: "/assets/images/Blog/bloglist1.png",
        title: "How to Register for an IFU: Step-by-Step Business Guide by Pestel & Partners",
        excerpt:
"IFU registration process, How to register IFU, IFU registration online, IFU application, IFU registration steps, Documents for IFU registration, Business IFU registration, IFU registration guide"      },
      {
        id: 3,
        image: "/assets/images/Blog/bloglist1.png",
        title: "AML & Fraud Prevention in Fintech: Best Practices to Stay Compliant",
        excerpt:
          "AML in fintech, Fintech fraud prevention, Anti money laundering compliance, AML regulations, KYC and AML, Fraud detection fintech, Financial crime prevention, Fintech",
      },
      {
        id: 4,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Cybersecurity Tips for Fintech Startups: Expert Insights from Pestel & Partners",
        excerpt:
          "Fintech cybersecurity, Cybersecurity for fintech startups, Fintech security best practices, Cyber risk management, Data protection fintech, Fintech cyber threats, Information security fintech",
      },
      {
        id: 5,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Smart Financial Strategies for SMEs to Grow and Scale Successfully",
        excerpt:
          "Financial strategies for SMEs, SME growth strategies, Business financial strategy, SME financial management, Cash flow management SMEs, SME scaling strategies, Profitability strategies SMEs",
      },
      {
        id: 6,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Financial Planning Tips for Small and Medium Businesses by Pestel & Partners",
        excerpt:
          "Financial planning for SMEs, Small business financial planning, Business budgeting, Financial forecasting, Working capital management, Expense management, SME financial planning tips",
      },
      {
        id: 7,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Why Audit Matters: Importance of Audit for Business Transparency",
        excerpt:
          "Importance of audit, Business audit, Financial audit benefits, Internal audit, External audit, Audit compliance, Business transparency",
      },
      {
        id: 8,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Taxation Strategy for Businesses: Compliance & Growth Guide by Pestel & Partners",
        excerpt:
          "Business taxation strategy, Tax planning for businesses, Corporate tax compliance, Business tax optimization, Tax advisory services, Tax regulations for companies, Strategic tax planning",
      },
      {
        id: 9,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Corporate Law Simplified: Legal Requirements Every Business Must Follow",
        excerpt:
          "Corporate law basics, Business legal requirements, Corporate compliance, Company law, Corporate governance, Legal compliance for businesses, Business law guide",
      },
      {
        id: 10,
        image: "/assets/images/Blog/bloglist1.png",
        title: "Company Creation & Registration: Legal and Financial Checklist for Startups",
        excerpt:
          "Company registration, Business formation, Company incorporation, Startup registration, How to register a company, Business licensing, Startup compliance",
      },
    ],
};

export default dataEN;
